import React, { useContext, useEffect, useRef, useState } from "react";

import LoadingIcon from "../../images/Loading_icon.gif";
import POSingleProject from "./POSingleProject";
import { UrlContext } from "../../contexts/UrlContext";

export default function POWithFilter(props) {
  const {
    searchInput,
    zohoIdFilter,
    statusFilter,
    ownerFilter,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
    filterPage,
    users,
    setFilterPage,
  } = props;

  const [projects, setProjects] = useState([]);
  const bottomRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMoreProjects, setHasMoreProjects] = useState(true);
  const { API_URL } = useContext(UrlContext);
  // Fetch projects from the API when the filter criteria change
  useEffect(() => {
    setProjects([]);
    setFilterPage(1);
    setHasMoreProjects(true);
  }, [
    searchInput,
    zohoIdFilter,
    statusFilter,
    ownerFilter,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
  ]);

  useEffect(() => {
    // Load more projects when the user scrolls to the bottom of the page
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !isLoading && hasMoreProjects) {
        setIsLoading(true);
      }
    });

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      if (bottomRef.current) {
        observer.unobserve(bottomRef.current);
      }
    };
  }, [isLoading, hasMoreProjects, setFilterPage]);

  useEffect(() => {
    // Create an AbortController instance
    const abortController = new AbortController();

    if (filterPage === 1) {
      setProjects([]);
    }

    // Fetch projects from the API based on the filter criteria and pagination
    const fetchProjects = async () => {
      setIsLoading(true);

      try {
        const url = `${API_URL}filter-lists`;

        // Pass the AbortController's signal to the fetch request
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchInput,
            zohoIdFilter,
            statusFilter,
            ownerFilter,
            prjTypeFilter,
            regionFilter,
            countryFilter,
            industryFilter,
            filterPage,
          }),
          signal: abortController.signal, // Pass the signal option
        });

        const data = await response.json();

        if (data.data.length > 0) {
          if (data.data.length < 100) {
            setHasMoreProjects(false);
          }

          if (filterPage === 1) {
            setProjects(data.data);
          } else {
            setProjects((prevProjects) => [...prevProjects, ...data.data]);
          }
        } else {
          setHasMoreProjects(false);
        }
      } catch (error) {
        console.log(error);
      }

      setIsLoading(false);
    };

    fetchProjects();

    // Cleanup function to cancel the fetch request
    return () => {
      abortController.abort();
    };
  }, [
    searchInput,
    zohoIdFilter,
    statusFilter,
    ownerFilter,
    filterPage,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
  ]);

  return (
    <div className="flex items-center justify-center">
      <div className="w-[97%]">
        {projects.map((project, index) => (
          <POSingleProject
            key={index}
            project={project}
            users={users}
            filtering={true}
          />
        ))}

        {isLoading && (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <img
              src={LoadingIcon}
              style={{ height: "50px" }}
              alt="Loading projects..."
            />
            <h4 style={{ marginTop: "20px" }}>please wait</h4>
          </div>
        )}

        {!isLoading && hasMoreProjects && projects.length > 0 && (
          <div ref={bottomRef} style={{ textAlign: "center", marginTop: "50px" }}>
            <img
              src={LoadingIcon}
              style={{ height: "50px" }}
              alt="Loading projects..."
            />
            <h4 style={{ marginTop: "20px" }}>please wait</h4>
          </div>
        )}

        {!isLoading && !hasMoreProjects && projects.length === 0 && (
          <div className="project-table-row">
            <div className="row-top-div" style={{ height: "45px" }}>
              <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                No project found
              </h5>
            </div>
            <div className="row-bottom-div"></div>
          </div>
        )}
      </div>
    </div>
  );
}
